import refs from '../helpers/refs'

class CProductAccordionSpecs {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    document.querySelectorAll('details').forEach((detailsElement) => {
      detailsElement.addEventListener('toggle', () => {
        if (detailsElement.open) {
          detailsElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-product-accordion-specs')
    .forEach(el => new CProductAccordionSpecs(el))
})
